import { Check, Loader2, X } from "lucide-react";
import { useW } from "./ctx";

/* "Condoor is building your submittal": the user is carried through the analysis, never dropped on a finished page. */
export default function Stage() {
  const w = useW();
  const run = w.project.run;
  const steps = run.steps;
  const done = steps.filter((s) => s.status === "done").length;
  const failed = run.status === "failed";
  const pct = Math.round(((done + (steps.some((s) => s.status === "running") ? 0.5 : 0)) / steps.length) * 100);
  return (
    <div className="mx-auto max-w-[760px] px-6 py-10" data-testid="analysis-stage">
      <h2 className="text-[24px] font-semibold tracking-[-0.01em]" data-testid="stage-headline">{failed ? "The analysis stopped" : "Condoor is building your submittal"}</h2>
      {failed && <p className="mt-1 text-[var(--red)]">{run.error}</p>}
      <div className="bar mt-5"><i style={{ width: `${failed ? 100 : pct}%`, background: failed ? "var(--red)" : undefined }} /></div>
      <ol className="mt-6 space-y-4">
        {steps.map((s, i) => (
          <li key={s.key} className="flex gap-3" data-testid={`stage-step-${s.key}`} data-status={s.status}>
            <span className={`mt-0.5 grid h-6 w-6 shrink-0 place-items-center rounded-full text-[12px] font-semibold ${s.status === "done" ? "bg-[var(--ink)] text-white"
              : s.status === "running" ? "border-2 border-[var(--accent)] text-[var(--accent)]" : s.status === "failed" ? "bg-[var(--red)] text-white" : "border border-[var(--line2)] text-[var(--muted)]"}`}>
              {s.status === "done" ? <Check size={13} /> : s.status === "running" ? <Loader2 size={13} className="spin" /> : s.status === "failed" ? <X size={13} /> : i + 1}
            </span>
            <div className="min-w-0">
              <p className={`font-medium ${s.status === "pending" ? "text-[var(--muted)]" : ""}`}>{s.title}{s.status === "running" ? <span className="text-[var(--muted)]"> · working…</span> : ""}</p>
              {s.findings?.length > 0 && (
                <ul className="mt-1 space-y-0.5 text-[13px] text-[var(--ink2)]">
                  {s.findings.map((f, j) => <li key={j} className="fade-up">{i >= 3 && i <= 4 ? "• " : ""}{f}</li>)}
                </ul>
              )}
            </div>
          </li>
        ))}
      </ol>
      {failed && w.role === "supplier" && (
        <div className="mt-8 flex gap-2"><button className="btn btn-primary" onClick={w.retry} data-testid="stage-retry">Try again</button></div>
      )}
    </div>
  );
}
